import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router'
import { MdOutlineAssignment } from 'react-icons/md'
import { ResourceList } from '@/Core/UI/CrudResource'
import { createCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { applyInitialFilter } from '@/Core/UI/CrudResource/Helpers/applyInitialFilter'
import { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'
import { AssignmentResource } from '../Resources/AssignmentResource'
import { assignmentFilterFromQuery, stripDashboardQuery } from '../Helpers/filterFromQuery'

/**
 * Tasks that originate from a transport request (ERP flow): executor IS NOT NULL.
 * Editable (own task fields — driver/vehicle/carrier/route/…; the request context
 * stays read-only), but not creatable/deletable here: creating tasks and deleting
 * are only allowed on the "without requests" page. See CrudResourceConfig.accessFn
 * and AssignmentCreateTemplate (which branches on the presence of a request).
 */
const AssignmentsWithRequestsPage = observer(() => {
    const { search } = useLocation()
    // Початковий статус-фільтр з query (перехід з головної: ?status=...).
    const filterInitialValues = useMemo(() => assignmentFilterFromQuery(search), [search])

    const listContext = useMemo(() => {
        const ctx = createCrudResourceContext({
            contextType: 'list',
            registryKey: 'Assignment.WithRequests.list',
            resource: {
                ...AssignmentResource,
                key: 'Assignment.WithRequests',
                // Заголовок картки списку — назва сторінки (перемикача над карткою більше
                // немає); resource.title лишається «Завдання» для заголовка картки запису
                headerPage: { ...AssignmentResource['headerPage'], title: 'Задачі з заявками' },
            },
            prefilter: { hasRequest: true },
        } as any)
        // Статус з query — як користувацький фільтр (щоб «Очистити» його скидав).
        applyInitialFilter(ctx, filterInitialValues)
        stripDashboardQuery()
        return ctx
    }, [filterInitialValues])

    return (
        <>
            <ResourceList crudContext={listContext} registryKey="Assignment.WithRequests.list" />
        </>
    )
})

export const pageConfig: IPageConfig = {
    route: '/assignments/with-requests',
    key: 'Assignment.WithRequests',
    title: 'Задачі з заявками',
    icon: <MdOutlineAssignment />,
}

export default AssignmentsWithRequestsPage
